export enum FilterType {
  Field = 'Field',
  Group = 'Group',
}
